<template>
    <component :is="dashboardComponent" :key="$store.state.national.mode" />
  </template>

<script>
// import { getContrastColor } from '@/utils/helpers';
import Dashboard from './app/Dashboard.vue';
import NewDashboard from './app/NewDashboard.vue';

export default {
  name: 'DashboardWrapper',
  //   mounted
  async mounted() {
    // window.addEventListener('resize', this.handleResize);
    // this.handleResize();

    const user = this.$store.getters['user/getUserProfile'];
    if (user?.profileComplete === false) {
      this.$router.push({ name: 'complete-profile' });
    }

    // let textColorPrimary = '';
    // let textColorSecondary = '';
    // if (this.entityLevel && this.entityName) {
    //   await this.$store.dispatch('national/getSlugBranding', { entityLevel: this.entityLevel, entityName: this.entityName });
    //   const meta = this.$store.getters['national/getMeta'];
    //   if (meta && meta.primaryColor && meta.secondaryColor) {
    //     textColorPrimary = getContrastColor(meta.primaryColor);
    //     textColorSecondary = getContrastColor(meta.secondaryColor);
    //     document.documentElement.style.setProperty('--highlight-color', meta.primaryColor);
    //     document.documentElement.style.setProperty('--secondary-color', meta.secondaryColor);
    //   } else {
    //     textColorPrimary = getContrastColor(meta.primaryColor);
    //     textColorSecondary = getContrastColor(meta.secondaryColor);
    //     document.documentElement.style.setProperty('--highlight-color', process.env.VUE_APP_HIGHLIGHT_COLOR);
    //     document.documentElement.style.setProperty('--secondary-color', process.env.VUE_APP_SECONDARY_COLOR);
    //   }
    // } else {
    //   this.$store.commit('national/resetCustom', {});
    //   textColorPrimary = getContrastColor(process.env.VUE_APP_HIGHLIGHT_COLOR);
    //   textColorSecondary = getContrastColor(process.env.VUE_APP_SECONDARY_COLOR);
    //   document.documentElement.style.setProperty('--highlight-color', process.env.VUE_APP_HIGHLIGHT_COLOR);
    //   document.documentElement.style.setProperty('--secondary-color', process.env.VUE_APP_SECONDARY_COLOR);
    // }
    // document.documentElement.style.setProperty('--text-color-primary', textColorPrimary);
    // document.documentElement.style.setProperty('--text-color-secondary', textColorSecondary);
  },
  props: {
    entityLevel: String,
    entityName: String,
  },
  computed: {
    dashboardComponent() {
      const { mode } = this.$store.state.national;
      return mode === 'beta' ? NewDashboard : Dashboard;
    },
    mode() {
      return this.$store.state.national.mode;
    }
  },
};
</script>
